import { logger } from './logger'

const BASE_URL = import.meta.env.VITE_NCB_BASE_URL || 'https://openapi.nocodebackend.com'
const INSTANCE_ID = import.meta.env.VITE_NCB_INSTANCE_ID || '53830_github_cloudflare_pages'
const API_KEY = import.meta.env.VITE_NCB_API_KEY

export const ncbClient = {
  async request(method, path, body = null, queryParams = {}) {
    const startTime = Date.now()
    
    // Build URL with instance parameter
    const url = new URL(`${BASE_URL}${path}`)
    url.searchParams.set('Instance', INSTANCE_ID)
    
    // Add additional query parameters
    Object.entries(queryParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        url.searchParams.set(key, value)
      }
    })
    
    // Prepare headers
    const headers = {
      'Content-Type': 'application/json',
    }
    
    if (API_KEY) {
      headers['Authorization'] = `Bearer ${API_KEY}`
    }
    
    // Log the request
    const logEntry = logger.logRequest('ncb', method, url.toString(), {
      headers,
      body: body ? JSON.stringify(body) : null
    })
    
    try {
      const requestOptions = {
        method,
        headers,
      }
      
      if (body && (method === 'POST' || method === 'PUT')) {
        requestOptions.body = JSON.stringify(body)
      }
      
      const response = await fetch(url.toString(), requestOptions)
      const duration = Date.now() - startTime
      
      let responseData
      const contentType = response.headers.get('content-type')
      
      if (contentType && contentType.includes('application/json')) {
        responseData = await response.json()
      } else {
        responseData = await response.text()
      }
      
      // Log the response
      logger.logResponse(logEntry.id, response.status, responseData, duration, {
        'content-type': contentType,
        'status': response.status,
        'statusText': response.statusText
      })
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`)
      }
      
      return responseData
      
    } catch (error) {
      const duration = Date.now() - startTime
      logger.logError(logEntry.id, error, 0)
      throw error
    }
  },

  // Convenience methods for common operations
  async createUser(userData) {
    return this.request('POST', '/create/users', userData)
  },

  async getUsers(queryParams = {}) {
    return this.request('GET', '/read/users', null, queryParams)
  },

  async getUserById(id) {
    return this.request('GET', `/read/users/${id}`)
  },

  async searchUsers(searchCriteria) {
    return this.request('POST', '/search/users', searchCriteria)
  },

  async updateUser(id, userData) {
    return this.request('PUT', `/update/users/${id}`, userData)
  },

  async deleteUser(id) {
    return this.request('DELETE', `/delete/users/${id}`)
  },

  // Generate example requests for testing
  getExampleRequests() {
    return [
      {
        name: 'Create User',
        method: 'POST',
        path: '/create/users',
        body: {
          username: 'testuser',
          password: 'securepassword123'
        }
      },
      {
        name: 'Get All Users',
        method: 'GET',
        path: '/read/users',
        queryParams: {
          page: 1,
          limit: 10,
          includeTotal: true
        }
      },
      {
        name: 'Search Users',
        method: 'POST',
        path: '/search/users',
        body: {
          username: 'test'
        }
      },
      {
        name: 'Get User by ID',
        method: 'GET',
        path: '/read/users/1'
      },
      {
        name: 'Update User',
        method: 'PUT',
        path: '/update/users/1',
        body: {
          username: 'updateduser',
          password: 'newpassword123'
        }
      },
      {
        name: 'Delete User',
        method: 'DELETE',
        path: '/delete/users/1'
      }
    ]
  }
}